import * as campaignApi from "../api/campaign";

export const LIST_CAMPAIGNS = "LIST_CAMPAIGNS";
export const CLEAR_CAMPAIGNS = "CLEAR_CAMPAIGNS";

export function clearCampaigns() {
  return { type: CLEAR_CAMPAIGNS };
}

export function listCampaigns(params) {
  return async (dispatch, getState) => {
    const { storage } = getState();
    const { paid } = storage;

    const campaigns = await campaignApi.listCampaigns({ ...params, paid });

    // Only fetch progress if we have campaigns
    if (
      campaigns?.data &&
      Array.isArray(campaigns.data) &&
      campaigns.data.length > 0
    ) {
      try {
        const progress = await campaignApi.listCampaignsProgress({
          paid,
          activeDivisionId: params.activeDivisionId,
          campaignIds: campaigns.data.map(({ _id }) => _id).filter(Boolean),
        });

        campaigns.data = campaigns.data.map((campaign) => {
          if (progress && progress[campaign._id]) {
            campaign.progress = progress[campaign._id];
          } else {
            campaign.progress = {};
          }
          return campaign;
        });
      } catch (error) {
        // If progress fetch fails, continue without progress data
        console.error("Error fetching campaign progress:", error);
        campaigns.data = campaigns.data.map((campaign) => {
          campaign.progress = {};
          return campaign;
        });
      }
    }
    dispatch({ type: LIST_CAMPAIGNS, campaigns });
  };
}
